import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import SubscriptionCommisionsTable from "./SubscriptionCommisionsTable";

const SubscriptionCommissions = () => {
  const [plans, setPlans] = useState([]);
  const [planLoading, setPlanLoading] = useState(false);
  const [selectedPlanId, setSelectedPlanId] = useState("");
  const [form, setForm] = useState({
    subscriptionplan: "",
    commision_amount: "",
    status: "active",
  });
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState(null);
  const [refresh, setRefresh] = useState(false);
  useEffect(() => {
    const fetchPlans = async () => {
      setPlanLoading(true);
      try {
        const res = await axios.get("/subscription/subscription_plan");
        setPlans(res?.data?.response?.plans || []);
      } catch (err) {
        toast.error("Failed to load plans");
      } finally {
        setPlanLoading(false);
      }
    };
    fetchPlans();
  }, []);

  const handlePlanChange = (e) => {
    const planId = e.target.value;
    setSelectedPlanId(planId);
    setForm((prev) => ({
      ...prev,
      subscriptionplan: planId,
    }));
  };

  const handleSubmit = async () => {
    console.log(form, "form");
    const { subscriptionplan, commision_amount, status } = form;
    if (!subscriptionplan || !commision_amount || !status) {
      toast.error("Please fill all fields");
      return;
    }

    setLoading(true);
    try {
      if (editId) {
        console.log(editId, "editID")
        // PUT REQUEST
        await axios.put(`/subscription/subscription-commisions/${editId}/`, {
          subscriptionplan: Number(subscriptionplan),
          commision_amount: Number(commision_amount),
          status,
        });
        toast.success("Commission updated successfully!");
      } else {
        await axios.post("/subscription/subscription-commisions/", {
          subscriptionplan: Number(subscriptionplan),
          commision_amount: Number(commision_amount),
          status,
        });
      }
      toast.success("Commission added successfully!");
      setSelectedPlanId("");
      setForm({
        subscriptionplan: "",
        commision_amount: "",
        status: "active",
      });
      setEditId(null);
      setRefresh((prev) => !prev);
    } catch (err) {
      toast.error("Failed to submit");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (row) => {
    console.log(row, "row")
    setSelectedPlanId(row.subscriptionplan);
    setForm({
      subscriptionplan: row.subscriptionplan,
      commision_amount: row.commision_amount,
      status: row.status,
    });
    setEditId(row.id);
  };
  return (
    <Box p={3}>
      <Toaster position="top-right" />
      <Typography variant="h5" gutterBottom>
        Subscription Commissions
      </Typography>

      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel>Select Plan</InputLabel>
        <Select
          value={selectedPlanId}
          label="Select Plan"
          onChange={handlePlanChange}
        >
          {planLoading ? (
            <MenuItem disabled>Loading...</MenuItem>
          ) : (
            plans.map((plan) => {
              const planId = plan?.data?.[0]?.id;
              const planName = plan?.plan_name;
              return (
                <MenuItem key={planId} value={planId}>
                  {planName}
                </MenuItem>
              );
            })
          )}
        </Select>
      </FormControl>

      {selectedPlanId && (
        <Box mt={2}>
          <TextField
            label="Subscription Plan ID"
            fullWidth
            sx={{ mb: 2 }}
            value={form.subscriptionplan}
            InputProps={{
              readOnly: true,
            }}
          />

          <TextField
            label="Commission Amount"
            fullWidth
            type="number"
            sx={{ mb: 2 }}
            value={form.commision_amount}
            onChange={(e) =>
              setForm({ ...form, commision_amount: e.target.value })
            }
          />

          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Status</InputLabel>
            <Select
              value={form.status}
              onChange={(e) => setForm({ ...form, status: e.target.value })}
              label="Status"
            >
              <MenuItem value="active">Active</MenuItem>
              <MenuItem value="inactive">Inactive</MenuItem>
            </Select>
          </FormControl>

          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={loading}
            startIcon={loading && <CircularProgress size={16} />}
          >
            {loading ? "Submitting..." : "Add Commission"}
          </Button>
        </Box>
      )}

      <SubscriptionCommisionsTable refresh={refresh} onEdit={handleEdit} />
    </Box>
  );
};

export default SubscriptionCommissions;
